import { gql } from "@apollo/client";

export const UPDATE_TICKET = gql`
  mutation updateTicket($input: UpdateTicketInput!) {
    updateTicket(input: $input) {
      id
    }
  }
`;
